export class CheckoutContext {

    public routeTo: string[] = []
    public isAnonymous: boolean = false
    constructor(isAnonymous: boolean = false) {
        this.isAnonymous = isAnonymous
    }
}